import { JsonObject, JsonProperty } from 'json2typescript';
import { ModelEntity } from '@pit/core';
import { IDtoUserRole } from '../interfaces/dto.user.role.interface';

// @dynamic
@JsonObject('DtoUserRole')
export class DtoUserRole extends ModelEntity implements IDtoUserRole {

    constructor(initValues: Partial<IDtoUserRole> = null) {
        super();

        if (initValues !== null) {
            Object.assign(this, initValues);
        }
    }

    @JsonProperty('code', String, true)
    public code?: string = null;

    @JsonProperty('description', String, true)
    public description?: string = null;

    @JsonProperty('level', Number, true)
    public level?: number = 0;

    @JsonProperty('text', String, true)
    public text?: string = null;

}
